var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Col, Row, TextField } from "@folio/stripes/components";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormattedMessage, useIntl } from "react-intl";
import { useInlineReportMutation } from "../../../hooks/useInlineReportMutation";
import { createScknReportSchema } from "../../../utils/validationUtils";
import { generateScknReport } from "../../../api/reportsService";
import { ScknReportResults } from "./ScknReportResults";
import { ReportSubmitSection } from "./ReportSubmitSection";
var transformFormToApiParams = function (data) { return ({
    year: Number(data.year),
}); };
var getDefaultValues = function () { return ({
    year: String(new Date().getFullYear()),
}); };
export var ScknReportForm = function () {
    var formatMessage = useIntl().formatMessage;
    var _a = useForm({
        resolver: zodResolver(createScknReportSchema(formatMessage)),
        defaultValues: getDefaultValues(),
    }), control = _a.control, handleSubmit = _a.handleSubmit;
    var _b = useInlineReportMutation({
        generateReport: function (reportKy, data) {
            return generateScknReport(reportKy, transformFormToApiParams(data));
        },
        successMessageId: "ui-br-agency.outputs.sckn-report.success.generate",
        errorMessageId: "ui-br-agency.outputs.sckn-report.error.generate",
    }), mutate = _b.mutate, isLoading = _b.isLoading, reportData = _b.data, successMessage = _b.successMessage, clearSuccessMessage = _b.clearSuccessMessage, errorModalOpen = _b.errorModalOpen, errorMessage = _b.errorMessage, closeErrorModal = _b.closeErrorModal;
    return (React.createElement(React.Fragment, null,
        React.createElement("form", { onSubmit: handleSubmit(function (data) { return mutate(data); }) },
            React.createElement("h2", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.report.sckn-report" })),
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.sckn-report.description" })),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, md: 4 },
                    React.createElement(Controller, { control: control, name: "year", render: function (_a) {
                            var _b;
                            var field = _a.field, fieldState = _a.fieldState;
                            return (React.createElement(TextField, __assign({}, field, { label: formatMessage({
                                    id: "ui-br-agency.outputs.sckn-report.field.year",
                                }), required: true, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message })));
                        } }))),
            React.createElement(ReportSubmitSection, { isLoading: isLoading, generateButtonId: "ui-br-agency.outputs.sckn-report.button.generate", successMessage: successMessage, onSuccessDismiss: clearSuccessMessage, errorModalOpen: errorModalOpen, errorMessage: errorMessage, onErrorClose: closeErrorModal })),
        reportData && React.createElement(ScknReportResults, { data: reportData })));
};
